class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupDesktopHover();
    this.setupDesktopSummaryClick();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  setupDesktopHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    this.addEventListener('mouseenter', () => {
      this.mainDetailsToggle.setAttribute('open', '');
    });

    this.addEventListener('mouseleave', () => {
      this.close();
    });
  }

  setupDesktopSummaryClick() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.addEventListener('click', (event) => {
      // Keyboard activation (event.detail === 0) keeps the default toggle
      // behavior so the menu stays reachable without a mouse
      if (event.detail === 0) return;

      const url = summary.dataset.url;
      if (!url || url === '#') return;

      event.preventDefault();
      window.location.href = url;
    });
  }
}

customElements.define('header-menu', HeaderMenu);
